import axiosInstance from './axiosInstance';

export interface BannerRow {
  id: string;
  name: string;
  width: number;
  height: number;
  gameIds: string[];
  createdAt?: string | null;
  updatedAt?: string | null;
}

export class BannerApi {
  static async list(skip = 0, limit = 20, query?: { name?: string }): Promise<{ list: BannerRow[]; total: number }> {
    const response = await axiosInstance.get('/cms/v1/banner', {
      params: {
        skip,
        limit,
        name: query?.name || undefined,
      },
    });
    return response.data.data;
  }

  static async create(payload: {
    name: string;
    width: number;
    height: number;
    gameIds?: string[];
  }): Promise<BannerRow> {
    const response = await axiosInstance.post('/cms/v1/banner', payload);
    return response.data.data.banner;
  }

  static async update(
    id: string,
    payload: Partial<Pick<BannerRow, 'name' | 'width' | 'height' | 'gameIds'>>,
  ): Promise<BannerRow> {
    const response = await axiosInstance.put(`/cms/v1/banner/${id}`, payload);
    return response.data.data.banner;
  }

  static async remove(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/banner/${id}`);
  }

  static async addGame(id: string, gameId: string): Promise<BannerRow> {
    const response = await axiosInstance.post(`/cms/v1/banner/${id}/game`, { gameId });
    return response.data.data.banner;
  }

  static async removeGame(id: string, gameId: string): Promise<BannerRow> {
    const response = await axiosInstance.delete(`/cms/v1/banner/${id}/game`, {
      data: { gameId },
    });
    return response.data.data.banner;
  }
}
